export default __webpack_public_path__ + "assets/images/decor.11472c.png";